import angular from 'angular'

function supplierCard() {
  return {
    restrict: 'E',
    replace: true,
    template: require('./_card-supplier.html')
  }
}

export default angular.module('directives.supplierCard', [])
  .directive('supplierCard', supplierCard)
  .name